import React from 'react'
import { useFormikContext } from 'formik'
import { TicketFormValues } from 'app/contact/support/TicketForm'
import { CountriesOptionsWrapperAllCountries } from 'core/widgets/CountriesDropdown/CountriesOptionsWrapper'
import { TicketFormContext } from '@cbgms/components/src/support-request/context/TicketFormContext'
import { useOrderAccountsContext } from 'app/workorder/contexts/use-order-account-context'
import { TicketSystem } from '@cbgms/api'

export const TicketFormContextProvider: React.FC = ({ children }) => {
  const { setFieldValue, values, initialValues } = useFormikContext<TicketFormValues>()
  const { selectedOrderAccount } = useOrderAccountsContext()
  const isAvailable = React.useMemo(
    () => (selectedOrderAccount?.Wholesaler?.TicketSystem || TicketSystem.NA) !== TicketSystem.NA,
    [selectedOrderAccount?.Wholesaler?.TicketSystem]
  )

  const value = {
    isAvailable,
    ticketType: values.TicketType,
    contactPreference: values.CallbackDetails.ContactPreference,
    vehicleCountry: values.Vehicle?.Country || '',
    clearPartValues: () => setFieldValue('Part', initialValues.Part),
    clearVehicleValues: () => setFieldValue('Vehicle', initialValues.Vehicle),
    CountriesOptionsWrapper: CountriesOptionsWrapperAllCountries
  }

  return <TicketFormContext.Provider value={value}>{children}</TicketFormContext.Provider>
}
